var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6.5V2.5H14V6.5H8.66667ZM2 9.16667V2.5H7.33333V9.16667H2ZM8.66667 14.5V7.83333H14V14.5H8.66667ZM2 14.5V10.5H7.33333V14.5H2ZM3.33333 7.83333H6V3.83333H3.33333V7.83333ZM10 13.1667H12.6667V9.16667H10V13.1667ZM10 5.16667H12.6667V3.83333H10V5.16667ZM3.33333 13.1667H6V11.8333H3.33333V13.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.b244c6d99dac54006d24692d5e9944de.svg";
export { ForwardRef as ReactComponent };